/* External Imports */
import { Box, Heading, Text } from '@chakra-ui/react';
/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';
/* Styles */
import styles from '@lb/Sections/aboutDevi/styles.module.css';

const AboutDeviSlide6 = ({ section }) => {
  return (
    <Box
      background={`#000 url(${config.imgPath}/d/46272/1684474033-ib_secion5bg.jpeg) no-repeat center top`}
      bgSize="cover"
      bgColor="#000"
      className={styles.section5Bg}
    >
      <Box
        maxW="1200px"
        mx="auto"
        minH="100vh"
        display="flex"
        position="relative"
        alignItems="center"
      >
        <Box
          display="flex"
          w="100%"
          justifyContent="space-between"
          gridGap="80px"
          alignItems="center"
          flexDir={{ base: 'column', xl: 'row' }}
        >
          <Box maxW="287px" textAlign="center">
            <Heading
              color="#FAEFE7"
              fontSize={{ base: '40px', lg: '50px' }}
              lineHeight="54px"
              fontFamily="'FedraSerifDisplay'"
              py={{ base: 8, md: 0 }}
              pb={4}
            >
              {section?.sectionContent?.[0]?.text}
            </Heading>
            <Text color="#D09700" fontSize={{ base: '18px', lg: '24px' }}>
              {section?.sectionContent?.[1]?.text}
            </Text>
          </Box>
          <Box display="flex" flexGrow={1} alignItems="center" flexDir="column">
            <Box
              display="flex"
              alignItems="center"
              gridGap={{ base: '5px', md: '20px' }}
              ml={{ base: '47px', md: '120px' }}
              mb={{ base: '20px', md: '40px' }}
            >
              <LazyLoadImageComponent
                src={`${config.imgPath}/d/46272/1684474084-lb_y_img.png`}
                alt="eyes"
                height={{ base: '75px', md: '111px' }}
                width={{ base: '75px', md: '111px' }}
              />
              <Box
                h="2px"
                width={{ base: '22px', md: '54px' }}
                bg="#FF981F"
              ></Box>
              <Text color="#FF981F" fontSize={{ base: '14px', md: '24px' }}>
                Anahata
              </Text>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              gridGap={{ base: '5px', md: '20px' }}
              mb={{ base: '20px', md: '40px' }}
              ml={{ base: '-126px', md: '-310px' }}
            >
              <Text color="#FF981F" fontSize={{ base: '14px', md: '24px' }}>
                Manipuraka
              </Text>
              <Box
                h="2px"
                width={{ base: '10px', md: '54px' }}
                bg="#FF981F"
              ></Box>

              <LazyLoadImageComponent
                src={`${config.imgPath}/d/46272/1684475462-lb_r_img.png`}
                alt="eyes"
                height={{ base: '75px', md: '111px' }}
                width={{ base: '75px', md: '111px' }}
              />
            </Box>
            <Box
              display="flex"
              alignItems="center"
              gridColumn="100px"
              gridGap={{ base: '5px', md: '20px' }}
              ml={{ base: '105px', md: '210px' }}
              mb={{ base: '20px', md: '40px' }}
            >
              <LazyLoadImageComponent
                src={`${config.imgPath}/d/46272/1684474088-lb_v_img.png`}
                alt="eyes"
                height={{ base: '75px', md: '111px' }}
                width={{ base: '75px', md: '111px' }}
              />
              <Box
                h="2px"
                width={{ base: '15px', md: '54px' }}
                bg="#FF981F"
              ></Box>
              <Text color="#FF981F" fontSize={{ base: '14px', md: '24px' }}>
                Swadhishthana
              </Text>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              gridGap={{ base: '5px', md: '20px' }}
              mb={{ base: '20px', md: '40px' }}
              ml={{ base: '-130px', md: '-280px' }}
            >
              <Text color="#FF981F" fontSize={{ base: '14px', md: '24px' }}>
                Muladhara
              </Text>
              <Box
                h="2px"
                width={{ base: '22px', md: '54px' }}
                bg="#FF981F"
              ></Box>

              <LazyLoadImageComponent
                src={`${config.imgPath}/d/46272/1684475405-lb_l_img.png`}
                alt="eyes"
                height={{ base: '75px', md: '111px' }}
                width={{ base: '75px', md: '111px' }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default AboutDeviSlide6;
